import { Injectable } from '@angular/core';
import { BehaviorSubject, filter } from 'rxjs';

@Injectable()
export class ComponentSendToHomeqDispatcher {
  constructor() {}

  private _subject = new BehaviorSubject<any>(null);

  data = this._subject.asObservable().pipe(filter(next => next != null));

  dataSent() {
    this._subject.next(null);
  }

  send(data: any) {
    this._subject.next(data);
  }
}
